const QuestionsData = [
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
];

export const accordionData = QuestionsData.map((e, index) => ({
  key: index,
  title: `distributionLanding:accordionData.question${e}`,
  content: `distributionLanding:accordionData.answer${e}`,
  isdivContainer: false,
}));
